(function($) {
  
    $(document).ready(function() {
        
    });
  
})(jQuery);

function initOverlayFullpage(){
    var $ = jQuery;
    $('.m-overlay-fullpage').click(function(){
        $('body').removeClass('is-overlay-visible');
        $('body').removeClass('is-searchform-filled');
        $("body").removeClass(function (index, className) {
            return (className.match (/is-popup-(.*)-shown/g) || []).join(' ');
        });
        $('body').removeClass('is-searchform-shown');
        $('body').removeClass('is-loginform-shown');
    })
}